module.exports = __webpack_public_path__ + "static/media/download.26839ed4.png";